import '@inbox-demo-nx/theme';

import { useDripsyTheme } from 'dripsy';
import AnimatedLottieView from 'lottie-react-native';
import { useEffect, useMemo, useState } from 'react';
import { ViewProps } from 'react-native';

import colorizeLottie from './colorizeLottie';
import animation from './toss-loading-indicator.json';
export default function CircleProgress({
  size,
  color,
  ...props
}: { size: number; color?: string } & ViewProps) {
  const { theme } = useDripsyTheme();
  const [LazyLottieView, setLazyLottieView] = useState<
    typeof AnimatedLottieView | null
  >(null);
  const coloredAnimation = useMemo(() => {
    return colorizeLottie(animation, {
      'layers.0.shapes.0.it.2.c.k': color || theme.colors.accent,
    });
  }, [color, theme.colors.accent]);

  useEffect(() => {
    import('lottie-react-native').then((module) =>
      setLazyLottieView(module.default)
    );
  }, []);

  return (
    LazyLottieView && (
      <LazyLottieView
        autoPlay
        style={{ width: size, height: size }}
        source={coloredAnimation}
        {...props}
      />
    )
  );
}
